import { AUDIENCE_STATUS } from 'modules/audiences/config/audiencesConsts';
import { MODULE_NAME as AUDIENCES_MODULE } from 'modules/audiences/config/routes';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isUserPermissionOrFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/utils/isUserPermissionOrFeatureFlagEnabled';
import { isVideoAccount } from '../../../../../../account-management';
import { isOpenExchangeAccount, isPmpAccount } from '../../../../../../account-management/accountType';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { COMBINED_AUDIENCES_REPORT_ID } from './combinedAudiencesReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const combinedAudienceReportConfig = {
    id: COMBINED_AUDIENCES_REPORT_ID,
    label: 'Combined Audiences',
    visibilityCondition: ({ permissions, configs: { selectedAccountConfig }, selectedAccount }) => {
        const { partnerTypes } = selectedAccount;

        const isSupportedAccountType =
            !isVideoAccount(partnerTypes) && !isPmpAccount(selectedAccount) && !isOpenExchangeAccount(selectedAccount);

        const isAllowed = isUserPermissionOrFeatureFlagEnabled(
            permissions,
            selectedAccountConfig,
            'ADS_CONSOLE_COMBINED_AUDIENCES',
            FEATURE_FLAGS.ADS_CONSOLE_COMBINED_AUDIENCES_ALLOWED
        );

        return isAllowed && isSupportedAccountType;
    },
    module: AUDIENCES_MODULE,
    endpoint: 'combined-audience-report',
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    searchPlaceholderMsgId: 'app.reports.firstParty.search.placeholder',
    searchField: FIELDS.AUDIENCE_NAME.field,
    sortMap: {
        [FIELDS.NAME.field]: FIELDS.AUDIENCE_NAME.field,
    },
    initialFilters: [
        {
            id: FILTER_TYPE.AUDIENCE_STATUS,
            type: FILTER_TYPE.AUDIENCE_STATUS,
            values: [
                {
                    value: AUDIENCE_STATUS.ALL_BUT_ARCHIVED,
                    label: 'All but archived',
                    messageId: 'report.audienceStatus.ALL_BUT_ARCHIVED',
                },
            ],
            accountConfigurations: { [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true' },
        },
    ],
    filters: [{ id: FILTER_TYPE.AUDIENCE_STATUS }],
};

export default combinedAudienceReportConfig;
